const { ContextManager } = require('@fiverr/context-manager');

/**
 * The Context key to use when stored within ContextManager.
 * @type {string}
 */
const FIVERR_CONTEXT_KEY = 'fiverr_context';

/**
 * The FiverrContext API to offer both data access and possible mutations around it.
 */
class FiverrContextAPI {
    constructor(fiverrContext) {
        Object.defineProperties(this, Object.getOwnPropertyDescriptors(fiverrContext));
    }

    /**
     * Updates existing ABTests using a given ABTests allocations result.
     * @param abTests
     */
    addABTests(abTests) {
        Object.assign(this.abTests, abTests);
    }

    /**
     * Sets rather if current request is pro experience or not.
     * @param isPro
     */
    setIsPro(isPro) {
        this.isPro = isPro;
    }

    /**
     * Forces current locale to a given custom one.
     * @param locale
     */
    setLocale(locale) {
        this.locale = locale;
    }
}

/**
 * Exposes a given representation of a FiverrContext object based on the runtime "ContextManager".
 * @param {FiverrContext} fiverrContext - The FiverrContext representation.
 *
 * @see https://github.com/fiverr/context-manager
 */
const exposeFiverrContext = (fiverrContext) =>
    ContextManager.with(FIVERR_CONTEXT_KEY, new FiverrContextAPI(fiverrContext), true);

/**
 * Checks rather FiverrContext is present over the current context.
 * @return {boolean}
 *
 * @see https://github.com/fiverr/context-manager
 */
const fiverrContextExists = () => ContextManager.exists(FIVERR_CONTEXT_KEY);

/**
 * Experimental API for getting the new FiverrContext.
 * You should NOT use this function once or ever without consulting with #ants.
 * @return {FiverrContextAPI}
 * @private
 */
const __experimental__getContext = () => ContextManager.get(FIVERR_CONTEXT_KEY);

module.exports = {
    FIVERR_CONTEXT_KEY,
    exposeFiverrContext,
    fiverrContextExists,
    __experimental__getContext,
    FiverrContextAPI,
};
